"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import API from "@ym-framework/api-utils";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchChangePassword = class extends Mixins(AccountSessionMixins) {
  get show() {
    return true;
  }
  batchEditPassword() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(
          this.$t("team_management.batch_password.comfirm_dialog.message", {
            number: this._controller.length
          }),
          this.$t(
            "team_management.batch_password.comfirm_dialog.title"
          ),
          {
            confirmButtonText: this.$t(
              "team_management.batch_password.comfirm_dialog.confirm"
            ),
            cancelButtonText: this.$t(
              "team_management.batch_password.comfirm_dialog.cancel"
            )
          }
        );
        let response = yield API.post(
          `api://base.auth/api/v1/user/password/edit/batch`,
          {
            users: ((selectItems) => {
              let items = [];
              for (let item of selectItems) {
                items.push(item.guid);
              }
              return items;
            })(this._controller)
          }
        );
        this.$message.success(
          this.$t(
            "team_management.batch_password.comfirm_dialog.success_message"
          )
        );
        yield UiConfirm.confirm(
          this.$t("team_management.batch_password.notice.message"),
          this.$t("team_management.batch_password.notice.title"),
          {
            confirmButtonText: this.$t(
              "team_management.batch_password.notice.confirm"
            ),
            cancelButtonText: this.$t(
              "team_management.batch_password.notice.cancel"
            )
          }
        );
        let result = yield API.post(
          `api://base.auth/api/v1/user/password/edit/batch/message/send`,
          {
            users: ((selectItems) => {
              let items = [];
              for (let item of selectItems) {
                items.push(item.guid);
              }
              return items;
            })(this._controller)
          }
        );
        this.$message.success(
          this.$t(
            "team_management.batch_password.notice.success_message"
          )
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("selectItem")
], BatchChangePassword.prototype, "_controller", 2);
BatchChangePassword = __decorateClass([
  Component
], BatchChangePassword);
export {
  BatchChangePassword as default
};
